import React, { JSXElementConstructor, ReactElement } from "react";
import { NoDataComponent } from "../../../../../ds";
import { AdsListDataResponse, AdsListPageFactory } from "../../interfaces";
import { AdsList } from "../screens/components";

export class AdsListPageFactoryImpl implements AdsListPageFactory {
    create(adsData: AdsListDataResponse | undefined): ReactElement<any, string | JSXElementConstructor<any>> {
        if (!adsData?.success) return <NoDataComponent />
        return <AdsList data={adsData.response.data} />
    }
}